import axios from "axios";
import router from "@/router/index";
import config from "./config.js";
import {
  Message
} from 'element-ui';

let promiseObj = {};
let cancel = null;
const CancelToken = axios.CancelToken;

window.promiseObj = promiseObj;

// 创建实例时设置配置的默认值
let instance = axios.create({
  timeout: 1000 * 190,
  withCredentials: true,
  baseURL: config.baseURL
});

const wsUrl = config.wsURL;

// 添加请求拦截器
// instance.interceptors.request.use(res => {
//     return res
// }, err => {
//     if (error.response) {
//         switch (error.response.status) {
//             case 401:
//                 router.replace({
//                     path: '/login',
//                 })
//         }
//     } else {
//         router.replace({
//             path: '/login',
//         })
//     }
//     return Promise.reject(err)
// });

// 添加响应拦截器
instance.interceptors.response.use(
  res => {
    return res;
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          router.replace({
            path: "/login"
          });
          break;
        default:
          Message.error('请联系开发人员。');
          break;
      }
    } else {
      // router.replace({
      //     path: "/login"
      // });
      Message.error('请联系开发人员。')
    }
    return Promise.reject(error);
  }
);

// const Authorization = localStorage.getItem('token');

const getHeader = () => {
  let obj = {};

  if (localStorage.getItem('BAILIAN-SHIBIE-TOKEN')) {
    obj['Authorization'] = localStorage.getItem('BAILIAN-SHIBIE-TOKEN');
  }
  if (localStorage.getItem('BAILIAN-SHIBIE-OFFICEWEBSITE-TOKEN')) {
    obj['BailianWebSiteToken'] = localStorage.getItem('BAILIAN-SHIBIE-OFFICEWEBSITE-TOKEN');
  }
  return obj;
}


const get = option => {
  return new Promise((resolve, reject) => {
    return instance({
      url: option.url,
      method: "get",
      params: option.data,
      headers: getHeader(),
      cancelToken: new CancelToken(c => {
        cancel = c;
      }),
      ...option
    })
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  })
};

const post = option => {
  return new Promise((resolve, reject) => {
    return instance({
      url: option.url,
      method: "post",
      data: option.data,
      headers: getHeader(),
      cancelToken: new CancelToken(c => {
        cancel = c;
      }),
      ...option
    })
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  })
};

const request = option => {
  const method = option.method.toLowerCase();
  if (method == "get") {
    return get(option);
  } else if (method == "post") {
    return post(option);
  } else {
    return new Promise((resolve, reject) => {
      return instance({
        ...option,
        method: method,
        headers: getHeader(),
        cancelToken: new CancelToken(c => {
          cancel = c;
        })
      })
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    })
  }
};

const getInstance = () => instance;

//上传
const upload = {
  // url: 'http://100.64.72.110:8001' + '/project/uploadData',
  url: config.baseURL + "/data/uploadData",
  header() {
    return getHeader()
    // 'Authorization': 'bd4579df-46b0-4994-9db1-ddfc08bf30d3'
  }
};

// 自定义识别上传
const defUpload = {
  url: config.baseURL + "/v3/custom_api/convertFile2Pic",
  header() {
    return getHeader()
    // 'Authorization': 'bd4579df-46b0-4994-9db1-ddfc08bf30d3'
  }
};

const mail = {
  url: config.baseURL + "/mail/uploadPicture",
  header() {
    return {};
  }
};

//更换单证-编辑页
const uploadChange = {
  // url: 'http://192.168.10.49:8013' + '/data/replaceCertiFile',
  url: config.baseURL + "/data/replaceCertiFile",
  header() {
    return {
      'Authorization': localStorage.getItem('BAILIAN-SHIBIE-TOKEN')
    }
    // 'Authorization': 'bd4579df-46b0-4994-9db1-ddfc08bf30d3'
  }
};

//上传文件-创建模板|测试页
const uploadFile = {
  // url: 'http://192.168.10.49:8013' + '/data/uploadFile',
  url: config.baseURL + "/data/uploadFile",
  header() {
    return {
      'Authorization': localStorage.getItem('BAILIAN-SHIBIE-TOKEN')
    }
    // 'Authorization': 'bd4579df-46b0-4994-9db1-ddfc08bf30d3'
  }
};

const uploadFile2 = {
  // url: 'http://100.64.72.110:8001' + '/project/uploadData',
  url: config.baseURL + "/data/replaceCategoryFile?billNo=",
  header() {
    return {
      'Authorization': sessionStorage.getItem('BAILIAN-PD-TEMPLATE-TOKEN')
    }
    // 'Authorization': 'bd4579df-46b0-4994-9db1-ddfc08bf30d3'
  }
};

// 票据识别上传
const invoiceRecognitionUpload = {
  url: config.baseURL + "/api/invoiceRecognition",
  header() {
    return getHeader()
    // 'Authorization': 'bd4579df-46b0-4994-9db1-ddfc08bf30d3'
  }
};

// 银行卡识别上传
const laiyOcrBankCardUpload = {
  url: config.baseURL + "/api/laiyOcrBankCard",
  header() {
    return getHeader()
    // 'Authorization': 'bd4579df-46b0-4994-9db1-ddfc08bf30d3'
  }
};

// 身份证识别上传
const laiyOcrIdCardUpload = {
  url: config.baseURL + "/api/laiyOcrIdCard",
  header() {
    return getHeader()
    // 'Authorization': 'bd4579df-46b0-4994-9db1-ddfc08bf30d3'
  }
};

// 营业执照识别上传
const laiyOcrLicenseUpload = {
  url: config.baseURL + "/api/laiyOcrLicense",
  header() {
    return getHeader()
    // 'Authorization': 'bd4579df-46b0-4994-9db1-ddfc08bf30d3'
  }
};

// 护照识别上传
const laiyOcrPassportUpload = {
  url: config.baseURL + "/api/laiyOcrPassport",
  header() {
    return getHeader()
    // 'Authorization': 'bd4579df-46b0-4994-9db1-ddfc08bf30d3'
  }
};

// 小语种识别
const getLanguageTypePicRecognitionData = {
  url: config.baseURL + "/api/getLanguageTypePicRecognitionData?languageType=",
  header() {
    return getHeader()
    // 'Authorization': 'bd4579df-46b0-4994-9db1-ddfc08bf30d3'
  }
};

// 印章
const getSealMark = {
  url: config.baseURL + "/api/getSealMark",
  header() {
    return getHeader()
    // 'Authorization': 'bd4579df-46b0-4994-9db1-ddfc08bf30d3'
  }
};

export default {
  getInstance,
  instance,
  wsUrl,
  request,
  get,
  post,
  promiseObj,
  upload,
  uploadFile,
  uploadChange,
  mail,
  getHeader,
  defUpload,
  uploadFile2,
  invoiceRecognitionUpload,
  laiyOcrBankCardUpload,
  laiyOcrIdCardUpload,
  laiyOcrLicenseUpload,
  laiyOcrPassportUpload,
  getLanguageTypePicRecognitionData,
  getSealMark
};